module.exports = __webpack_public_path__ + "static/assets/e3cc49b6555f37b43d85e1beb5df7aa7.gif";